import { render, staticRenderFns } from "./ListPataModal.vue?vue&type=template&id=26ca8dee"
import script from "./ListPataModal.vue?vue&type=script&lang=js"
export * from "./ListPataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports